import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'localize'})
export class LocalePipe implements PipeTransform {

    private isFr(): boolean {
        return navigator.language == "fr" || navigator.language == "fr-FR";
    }

    transform(libelle: { language: string, fr: string, en: string }) {
    if (libelle) {
        if (this.isFr()) {
        if (libelle.fr) {
          return libelle.fr;
        }
        else {
          return "";
        }
      } else {
        if (libelle.en) {
          return libelle.en;
        }
        else {
          return "";
        }
      }
    }
    else {
      return "";
    }
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/pipe/locale.pipe.ts